module.exports = __webpack_public_path__ + "img/pnap.0cb6fe69.svg";